import { render, staticRenderFns } from "./UserReservation.vue?vue&type=template&id=29ecf542&scoped=true&"
import script from "./UserReservation.vue?vue&type=script&lang=js&"
export * from "./UserReservation.vue?vue&type=script&lang=js&"
import style0 from "./UserReservation.vue?vue&type=style&index=0&id=29ecf542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecf542",
  null
  
)

export default component.exports